import Table from './Table.js';

export default Table;
